import { render, staticRenderFns } from "./setWarnInsect.vue?vue&type=template&id=6df3e836&scoped=true&"
import script from "./setWarnInsect.vue?vue&type=script&lang=js&"
export * from "./setWarnInsect.vue?vue&type=script&lang=js&"
import style0 from "./setWarnInsect.vue?vue&type=style&index=0&id=6df3e836&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df3e836",
  null
  
)

export default component.exports